export * from "./body/ModalBody";
export { default as ModalBody } from "./body/ModalBody";
export * from "./footer/ModalFooter";
export { default as ModalFooter } from "./footer/ModalFooter";
export * from "./GenericModal";
export { default as GenericModal } from "./GenericModal";
export * from "./header/ModalHeader";
export { default as ModalHeader } from "./header/ModalHeader";
